import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RangesService} from '../../../../../common/api/dictionaries/ranges.service';

@Injectable()
export class BackofficeRangesService extends RangesService {
    static readonly context = 'backoffice'
    constructor(http: HttpClient) {
        super(http, BackofficeRangesService.context);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/backoffice.ranges.service.ts